import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  appointmentTimeDurationOptions,
  procedureTimeDurationOptions,
} from "../../config/constants/options";
import { SlotsError, SlotsType, UserSettingState } from "../../types/setting";

const getDefaultSlots = (): { procedure: SlotsType[]; consultation: SlotsType[] } => {
  const daysOfWeek = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const defaultSlot: SlotsType[] = daysOfWeek.map((day) => ({
    name: day,
    isChecked: true,
    timeSlots: [{ startTime: null, endTime: null }],
  }));

  return {
    procedure: defaultSlot,
    consultation: defaultSlot,
  };
};

const initialState: UserSettingState = {
  formData: {
    doctor: "",
    branch: "",
    appointmentDuration: { label: "10 Minutes", value: "10" },
    procedureDuration: { label: "20 Minutes", value: "20" },
    workingDays: "",
    workingHours: "",
  },
  errors: {},
  selectOptions: {
    doctor: [],
    branch: [],
    appointmentDuration: appointmentTimeDurationOptions,
    procedureDuration: procedureTimeDurationOptions,
  },
  slots: getDefaultSlots(), 
  slotsError: {},
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<any>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (state, action: PayloadAction<any>) => {
      state.selectOptions = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    setTimeSlots: (state, action: PayloadAction<any>) => {
      state.slots = { ...state.slots, ...action.payload };
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData
      state.errors = {};
      state.slots = getDefaultSlots(); 
      state.slotsError = {
        procedure: [{ day: "", timeSlots: [] }],
        consultation: [{ day: "", timeSlots: [] }],
      };
    },
    setSlotsError: (state, action: PayloadAction<SlotsError>) => {
      state.slotsError = action.payload;
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
  setTimeSlots,
  setSlotsError,
} = settingSlice.actions;

export default settingSlice.reducer;
